module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image",
    class: 'lote-img-status' + _vm.lote.status
  }, [(_vm.video !== null) ? _c('video', {
    attrs: {
      "autoplay": ""
    },
    on: {
      "ended": _vm.onEnd
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.video,
      "type": "video/mp4"
    }
  })]) : _vm._e(), _vm._v(" "), _c('img', {
    ref: "imagem",
    class: _vm.video !== null ? 'hide' : '',
    attrs: {
      "src": _vm.imagem
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d068e9e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/apresentacao-lotes/lote-imagens.vue
// module id = 2010
// module chunks = 3